<template>
    <div role="listitem" :id="value ? value : null" :class="[{divided: divided, 'opacity-75': disabled, 'border p-16': bordered, 'rounded-sm': !divided}, selected && bordered ? 'border-success' : '']" class="relative feature-item block">
        <span v-if="selected" class="absolute right-0 top-0 rounded-bl-lg bg-success pr-2 pt-2 pl-4 pb-4 z-1"><Icon :icon="icons.check" color="white" x-small/></span>
        <div class="flex flex-column">
            <div class="flex flex-column sm:flex-row w-full">
                <div class="flex flex-column flex-grow-x-1">
                    <component v-if="title" :is="titleTag" v-bind="titleToProps" class="font-heading text-heading-color font-semi-bold mb-0 leading-tight text-md">{{
                            title
                        }}
                    </component>
                    <p v-if="subtitle" class="font-heading text-subtext-color mb-0 mt-4 leading-normal truncate text-xs">{{ subtitle }}</p>
                    <div v-if="description" class="mb-0 mt-8 leading-spaced whitespace-pre-wrap text-sm" v-html="description"/>

                    <slot/>
                </div>
                <div v-if="image || $slots.image || $slots.info" class="flex flex-row-reverse justify-between sm:flex-column items-end mt-16 sm:mt-0 sm:ml-16 md:ml-32 xl:ml-64 overflow-hidden">
                    <slot name="info"/>

                    <div v-if="image || $slots.image" :class="{'sm:mt-12': $slots.info}">
                        <lazy-image-modal v-if="thumbnail && image" :src="[{path: image, title: description ? description : title, size: {width: 300, md: {width: 600}}, preview: {size: {width: imageSize}}}]" rounded/>
                        <cdn-image v-else-if="image" :width="imageSize" :height="imageSize" :src="image" class="rounded"/>
                        <slot name="image"/>
                    </div>
                </div>
            </div>
            <slot name="actions"/>
        </div>
    </div>
</template>

<script>
import {checkIcon} from "../../config";

export default {
    name: "FeatureItem",

    props: {

        value: {
            type: String,
            default: null
        },

        // Whether to create an anchor when the user clicks on the title
        linkable: {
            type: Boolean,
            default: false
        },

        // The vue router 'to' for the title and the image when the full card shall not be rendered as a link
        titleTo: {
            type: [String, Object],
            default: null
        },

        // Whether the resource item shall get additional spacing and multiple items shall be
        // divided with a border
        divided: {
            type: Boolean,
            default: false
        },

        // Whether the resource item shall get a border style
        bordered: {
            type: Boolean,
            default: false
        },

        // Whether the resource item shall get a selected style
        selected: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        },

        // The src of an image to display. Is only displayed within a modal if thumbnail is present
        image: {
            type: [String, Object],
            default: null
        },

        // The thumbnail src of an image to display
        thumbnail: {
            type: [String, Object],
            default: null
        },

        // The title to display for the item
        title: {
            type: String,
            default: null
        },

        // The subtitle to display for the item
        subtitle: {
            type: String,
            default: null
        },

        // The subtitle to display for the item
        description: {
            type: String,
            default: null
        }
    },

	data() {
		return {
			icons: {
				check: checkIcon,
			}
		}
	},

    computed: {
        titleTag() {
            if (this.titleTo || (this.linkable && this.value)) {
                return resolveComponent('NuxtLink');
            }

            return 'p';
        },

        titleToProps() {
            if (this.titleTo) {
                return {
                    to: this.titleTo
                };
            }

            if (this.linkable && this.value) {
                return {
                    to: {hash: `#${this.value}`}
                };
            }

            return null;
        },

        imageSize() {
            return this.$breakpoint.xsOnly ? 80 : 112;
        }
    }

}
</script>
<style>
.app .feature-item.divided + .feature-item.divided {
  margin-top: 24px;
  padding-top: 24px;
}
</style>